module.exports = __webpack_public_path__ + "static/media/ins9.af0635cd.jpg";